import { DateRange } from 'react-day-picker'

import { TFilterValue } from '../models/IAccordionFilters'

export const prepareDateRangeValue = (currentValue: TFilterValue) => {
  const dateRangeValue: DateRange = { to: undefined, from: undefined }

  if (Array.isArray(currentValue)) {
    if (currentValue) {
      dateRangeValue.from = new Date(currentValue[0])
      dateRangeValue.to = new Date(currentValue[1])
    }

    return dateRangeValue
  }

  if (typeof currentValue === 'string') {
    dateRangeValue.from = currentValue ? new Date(currentValue as string) : undefined
    dateRangeValue.to = undefined

    return dateRangeValue
  }

  return currentValue as DateRange
}
